// todo rename to NotificationsCategoryType
export enum PersonalNotificationsCategoryType {
    Unknown = -1,
    New = 0,
    Seen = 1,
    Visited = 2,
}
